import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SimvizComponent } from 'src/app/components/simulation/simviz/simviz.component';
import { RosbagPlayerComponent } from '../../components/gui/rosbag-player/rosbag-player.component';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared.module';
import { ThreeModule } from '../three.module';
import { SimulationRoutingModule } from './simulation-routing.module';
import { SimulationDetailsComponent } from 'src/app/components/simulation/simulation-details/simulation-details.component';
import { SimulationComponent } from 'src/app/components/simulation/simulation.component';
import { SimulationPageComponent } from 'src/app/components/simulation/simulation-page/simulation-page.component';
import { RouterModule } from '@angular/router';
import { SimpleSimulationContainerComponent } from 'src/app/components/simulation/simple-simulation/simple-simulation-container/simple-simulation-container.component';
import { StepOneComponent } from 'src/app/components/simulation/simple-simulation/step-one/step-one.component';
import { StepTwoComponent } from 'src/app/components/simulation/simple-simulation/step-two/step-two.component';
import { StepThreeComponent } from 'src/app/components/simulation/simple-simulation/step-three/step-three.component';
import { NewSimpleSimulationComponent } from 'src/app/components/dialogs/new-simple-simulation/new-simple-simulation.component';
import { ProductionLineDialogComponent } from 'src/app/components/dialogs/production-line-dialog/production-line-dialog.component';
import { HardwareDialogComponent } from 'src/app/components/dialogs/hardware-dialog/hardware-dialog.component';
import { SimulationWizardContainerComponent } from 'src/app/components/simulation/simulation-wizard/gui-container/simulation-wizard-container.component';
import { SelectPatternsComponent } from 'src/app/components/simulation/simulation-wizard/gui-container/patterns/select-patterns.component';
import { SelectHardwareComponent } from 'src/app/components/simulation/simulation-wizard/gui-container/hardware/select-hardware.component';
import { SelectSoftwareComponent } from 'src/app/components/simulation/simulation-wizard/gui-container/software/select-software.component';
import { SimulationWizardSummaryComponent } from 'src/app/components/simulation/simulation-wizard/gui-container/summary/simulation-wizard-summary.component';
import { ProductModule } from '../product/product.module';
import { ProductionLineModule } from '../production-line/production-line.module';
import { RenameSimulationComponent } from '../../components/dialogs/rename-simulation/rename-simulation.component';
import { InstalledRobotSimulationWizardComponent } from 'src/app/components/simulation/installed-robot-simulation-wizard/installed-robot-simulation-wizard.component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ThreeModule,
    SimulationRoutingModule,
    SharedModule,
    DragDropModule,
    RouterModule,
    MatMenuModule,
    ProductModule,
    ProductionLineModule,
  ],
  declarations: [
    SimulationComponent,
    SimvizComponent,
    RosbagPlayerComponent,
    RenameSimulationComponent,
    SimulationDetailsComponent,
    SimulationPageComponent,
    ProductionLineDialogComponent,
    NewSimpleSimulationComponent,
    HardwareDialogComponent,
    SimpleSimulationContainerComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    SimulationWizardContainerComponent,
    SelectPatternsComponent,
    SelectHardwareComponent,
    SelectSoftwareComponent,
    SimulationWizardSummaryComponent,
    InstalledRobotSimulationWizardComponent,
  ],
  exports: [SimvizComponent, RosbagPlayerComponent, SimulationPageComponent],
})
export class SimulationModule {}
